module.exports = {"Type":"Expression","Fields":[{"label":"Expression","type":"multiline","name":"text","serializeTo":"q"}],"Header":{"Color":"black","BackgroundColor":"#EE1010","Text":null}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/Expression.json
// module id = 697
// module chunks = 0